<div class="content">
  <rt-requisitions-notes-container />
</div>
